import { consts } from "../../shim/jsbridge";
import { RiskToleranceCardConfig } from "./@types";

export const riskToleranceLevelConfig: RiskToleranceCardConfig[] =
  consts.risk_tolerance_levels;
